import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  height: 100vh;
`;

export const CardsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  width: 100%;
  padding: 0 40px 0 5px;
`;

export const ContentFilters = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1em;
  margin: 2em 0px;
  width: 20%;
`;

export const SearchField = styled.div`
  margin-right: 0.5rem;
  width: 267px;
  height: 40px;
  position: relative;
  background: ${({ theme }) => theme.neutral.white};
  border-radius: 5px;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  svg {
    position: absolute;
    right: 10px;
  }
  input {
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: #989898;
  }
`;
